import CityManagementPage from "./shared/CityManagementPage";
import { allCityConfigs } from "./shared/cityConfigExtended";

export default function Stockport() {
  return <CityManagementPage config={allCityConfigs.stockport} />;
}